import * as React from "react";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "../hooks";
import { isRequired } from "../hooks/useForm";
import { AuthContext, CaricoMerceContext } from "../contexts";
import { useContext } from "react";
import { Button, IconButton, InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import { CreaViaggioDialog, ViaggiTable } from "../components";
import AddIcon from '@mui/icons-material/Add';


const MagViaggiCustom = () => {
  const { codiceMenu } = useParams();
  let navigate = useNavigate();
  const inputRef = React.useRef();
  const [isCreaViaggioDialogOpen, setIsCreaViaggioDialogOpen] = React.useState(false);

  const {
    state:{
      RicercaColumns,
      RicercaViaggi,
    },
    getArrivoCustom,
    getRicercaViaggiCustom, 
    getViaggiCustomViaggio,
    resetRicercaData,
    postCreaViaggioCustom
  } = useContext(CaricoMerceContext);


  const {
    state:{      
      visibleMenu,
    },

  } = useContext(AuthContext);

  const validations = [
    ({ code }) => isRequired(code) || { code: "*Barcode obbligatorio" },
  ];

  
  //17/10/2025 Greg: Segnalato da transmart, cambiando pagina da menudrawer la pagina non si aggiorna
  const onCodiceMenuChange = () => {
    resetRicercaData();

    setTimeout(() => {
      inputRef.current.focus();
    }, 100);

    getRicercaViaggiCustom(codiceMenu);    
  };

  React.useEffect(() => {
    // non chiamo onCodiceMenuChange, altrimenti al primo accesso della pagina viene chiamato due volte
    // onCodiceMenuChange();
    
  }, []);

  React.useEffect(() => {
    onCodiceMenuChange();
  }, [codiceMenu]);

  const {
    values: barcodeForm,
    changeHandler,
    touched,
    errors,
    isValid,
  } = useForm(
    {
      code: "",
    },
    validations
  );

  const onkeyEnter = (event) => {
    if (event === 13) {
      inputRef.current.blur();
      if (barcodeForm.code && isValid) {
        getArrivoCustom(barcodeForm.code,codiceMenu,navigate);
      }
    }
  };


  const isCreaViaggioActive = () => {
      let creaViaggioActive = false;
    visibleMenu.forEach((element) => {


      if ( element.codiceMenu === codiceMenu ){
        if (element.creaViaggioActive === true) {
          creaViaggioActive = true;
        }
      }
    });


    return (creaViaggioActive);
  }

  return (
    <>
      {/* {isCreaViaggioActive ? (
      <Stack direction={"row"} spacing={2} m={2}>
        <Button 
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setIsCreaViaggioDialogOpen(true)}
        >
          CREA VIAGGIO
        </Button>
      </Stack>):(<></>)} */}

      <Stack direction={"row"} spacing={2} m={2}>
        <TextField
          id="outlined-basic"
          label="Barcode viaggio"
          variant="outlined"
          placeholder="Inserire il barcode"
          fullWidth
          autoFocus
          autoComplete="off"
          inputRef={inputRef}

          onKeyPress={(e) => onkeyEnter(e.charCode)}
          onChange={(e) => changeHandler("code", e.target.value)}
          error={Boolean(touched.code && errors.code)}

          value={barcodeForm.code || ""}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton color="primary" disabled={!isValid}>
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <ViaggiTable
        columnsData = {RicercaColumns}
        rowsData    = {RicercaViaggi}
        navigate    = {navigate}
        detailFunc  = {getViaggiCustomViaggio}
        codiceMenu  = {codiceMenu}
      />

            
      <CreaViaggioDialog 
        isOpen={isCreaViaggioDialogOpen}
        setIsOpen={setIsCreaViaggioDialogOpen} 
        postCreaViaggio={postCreaViaggioCustom} 
        getRicerca={getRicercaViaggiCustom}
        codiceMenu={codiceMenu}
      />



    </>
  );
};
export default MagViaggiCustom;